
export default (data) => {
    let menuItems = document.getElementsByClassName('menuItems');
    let mn;
    for (mn = 0; mn < menuItems.length; mn ++) {
        menuItems[mn].classList.remove('text-heartOrange');
    }

    let namespace = data.next.namespace;
    let menuItemName = 'menuItem-' + namespace;

    let theMenuItem = document.getElementById(menuItemName);

    if (theMenuItem != null && theMenuItem != undefined) {
        theMenuItem.classList.add('text-heartOrange');
    }
}